import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const bitacoraProyectoService = {
  getBitacoraByIdProyecto,
}

async function getBitacoraByIdProyecto(id) {
  return await ApiBudgety.get('BitacoraProyecto/FindAllByIdProyecto/' + id, {
    headers: {
      ACCION: MenusSistema.proyecto_gestion.accesos.ver_bitacora,
      MENU: MenusSistema.proyecto_gestion.id,
    },
  })
}
